export default __webpack_public_path__ + "static/media/stella-1.0b50137f.png";